<template>
  <div
    ref="ContentBoxIconCanvasAsset"
    data-test-id="block-wrapper"
    class="content-box-icon flex items-stretch mx-auto transition duration-500 ease-in-out-quart select-none pointer-events-none"
    :class="[{ 'opacity-0': !isLoaded }]"
  >
    <div class="content-box-icon-wrapper w-full flex flex-col justify-between" :class="bgClass">
      <div class="flex-grow flex justify-center items-center py-10">
        <div class="h-24 w-24 md:h-34 md:w-34 overflow-hidden">
          <div class="transform transition ease-in-out-quart duration-800" :class="[{ 'translate-y-full': !isLoaded }]">
            <SvgServiceIcons :service="service" class="h-24 w-24 md:h-34 md:w-34 text-bitter-chocolate" />
          </div>
        </div>
      </div>
      <div class="content flex flex-wrap content-center justify-center bg-bitter-chocolate">
        <div v-for="(text, index) of getLabels" class="overflow-hidden mr-2 last:mr-0">
          <span
            class="text font-druk uppercase text-display-10 md:text-display-14 leading-10 md:leading-15 block transform transition ease-in-out-quart duration-800 px-1"
            :class="[bgClass, { 'translate-y-full': !isLoaded }]"
            data-test-id="text-label"
          >
            {{ text }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    service: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true,
      default: ''
    },
    bgClass: {
      type: String,
      default: 'bg-coffee'
    }
  },
  data () {
    return {
      isLoaded: false
    }
  },
  computed: {
    getLabels () {
      return this.label.split(' ')
    }
  },
  mounted () {
    this.useIntersectionObserverToShowContent()
  },
  methods: {
    useIntersectionObserverToShowContent () {
      try {
        const observer = new IntersectionObserver(this.showContentCallback, {
          threshold: 0.2
        })
        observer.observe(this.$refs.ContentBoxIconCanvasAsset)
      } catch (error) {
        this.isLoaded = true
      }
    },
    showContentCallback (entries, observer) {
      if (!this.isLoaded) {
        const [entry] = entries
        if (entry && entry.isIntersecting) {
          this.isLoaded = true
        }
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.text {
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.content-box-icon {
  width: 100%;
  max-width: 100%;

  .content-box-icon-wrapper {
    height: 274px;
  }

  .content {
    height: 100px;
  }

  @screen md {
    max-width: 420px;

    .content-box-icon-wrapper {
      height: 400px;
    }

    .content {
      height: 146px;
    }
  }
}
</style>
